import classNames from 'classnames';
import { useField } from 'formik';

import { useMemo } from 'react';
import useInput from '../hooks/useInput';
import Span from './Span';

type PropsFormikSwitch = {
  id?: string;
  name: string;
  value?: string;
  label: string;
  title?: string;
  classInput?: string;
  className?: string;
  disabled?: boolean;
  inputProps?: object;
}

export function FormikSwitch(
  {
    id: defaultId,
    name,
    value,
    label,
    title,
    classInput,
    className,
    disabled = false,
    inputProps = {}
  }: PropsFormikSwitch
) {
  const [field, meta] = useField({
    name,
    value,
    type: 'switch'
  });
  const { id } = useInput(defaultId, label);
  const initialValue = useMemo(()=>{
    return String(meta.value) === 'true';
  }, [meta]);
  return (
    <div
      className={classNames(
        'form-check form-switch',
        className
      )}
    >
      <input
        id={id}
        className={classNames(
          'form-check-input',
          classInput
        )}
        type="checkbox"
        disabled={disabled}
        {...inputProps}
        {...field}
        defaultChecked={initialValue}
        role="switch"
      />
      {!title ? (
        <label className="form-check-label" htmlFor={id}>
          {label}
        </label>
      ) : (
        <Span title={title}>
          <label className="form-check-label" htmlFor={id}>
            {label}
          </label>
        </Span>
      )}
    </div>
  );
}

export default FormikSwitch;
